export enum EventStep {
  STARTED = 'STARTED',
  FULFILLED = 'FULFILLED',
}
